/** @file quadPoint: the screen point at quad parameters `(u, v)` of a quad `[tl, tr, br, bl]` (bilinear). */

type P2 = readonly [number, number];

/** Bilinear in the four corners: exact at the corners and the edge midpoints of any quad. */
export function quadPoint(c: readonly P2[], u: number, v: number): [number, number] {
  const at = (i: number): P2 => c[i] ?? [0, 0];
  const w = [(1 - u) * (1 - v), u * (1 - v), u * v, (1 - u) * v];
  let x = 0;
  let y = 0;
  for (let i = 0; i < 4; i++) { x += (w[i] ?? 0) * at(i)[0]; y += (w[i] ?? 0) * at(i)[1]; }
  return [x, y];
}
